import { cn } from "./classNames-DcGnTh2N.js";
import { Tooltip, copyToClipboard } from "./utils-BLJzxVW-.js";
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Clipboard/Clipboard.tsx
const Clipboard = ({ ref, text: textProp, children, tooltip = "Copy to Clipboard", tooltipPlacement = "top", tooltipVariant: tooltipVariantProp = "action", asChild = false, onClick, className, ...restButtonProps }) => {
	const [isTooltipOpen, setIsTooltipOpen] = useState(false);
	const [state, setState] = useState("ready");
	const text = typeof textProp === "function" ? textProp() : textProp;
	const copy = async (text) => {
		try {
			if (!document.hasFocus()) window.focus();
			await copyToClipboard(text);
			setState("copied");
		} catch {
			setState("error");
		}
	};
	const handleOnClick = (event) => {
		setIsTooltipOpen(true);
		if (text && state === "ready") copy(text);
		onClick?.(event);
	};
	const handleOnOpenChange = (open) => {
		if (!open && state !== "ready") setState("ready");
		setIsTooltipOpen(open);
	};
	const tooltipContent = (() => {
		if (!text) return "Nothing to copy";
		if (state === "error") return "Failed to copy";
		if (state === "copied") return "Copied to Clipboard";
		return tooltip;
	})();
	const tooltipVariant = state === "ready" && !!text ? tooltipVariantProp : "action";
	const hasTooltipContent = tooltipContent !== null && tooltipContent !== void 0;
	return /* @__PURE__ */ jsxs(Tooltip.Root, {
		open: isTooltipOpen,
		onOpenChange: handleOnOpenChange,
		children: [/* @__PURE__ */ jsx(Tooltip.Trigger, {
			...restButtonProps,
			asChild,
			keepOpenOnClick: true,
			onClick: handleOnClick,
			className: cn("tw:cursor-pointer", className),
			ref,
			children: children ?? text
		}), hasTooltipContent && /* @__PURE__ */ jsx(Tooltip.Content, {
			keepOpenOnPointerDownOutside: true,
			placement: tooltipPlacement,
			variant: tooltipVariant,
			children: tooltipContent
		})]
	});
};
//#endregion
export { Clipboard };

//# sourceMappingURL=Clipboard-CzD_Mdqp.js.map